import AXIOS from '@/axios-instance';

export default {

  addProcessCharacteristic(characteristic) {
    return AXIOS.post("/processCharacteristic", characteristic);
  },
  retrieveProcessCharacteristics(type) {
    return AXIOS.get("/processCharacteristic");
  },
  retrieveProcessMap() {
    return AXIOS.get("/processCharacteristic/map");
  },
  addCustomField(field){
    return AXIOS.post("/processCharacteristic/field", field);
  },
  getCustomFields(){
    return AXIOS.get("/processCharacteristic/field");
  },
  deleteCharacteristic(id){
    return AXIOS.delete("/processCharacteristic/"+id);
  },
  updateProcessCharacteristic(characteristic){
    return AXIOS.put("/processCharacteristic", characteristic);
  },
  connectModelToCharacteristic(characteristicId, modelUUID){
    return AXIOS.post("/processCharacteristic/connect", {
      CHARACTERISTIC: characteristicId,
      UUID: modelUUID
    })
  }
}